import React, { Component } from 'react';
import classes from "./ReportsPageTabs.module.css";
import StudentAttendanceTable from '../StudentAttendanceTable/StudentAttendanceTable';
import ResourceAPIController from '../../webServices/ResourceAPIController';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';
import ProgressComponent from '../UI/ProgressComponent/ProgressComponent';
import Button from '../UI/Button/Button';
import SortHelper from '../../utilities/SortHelper';
import TechLogo from '../../assets/icons/tech-logo.svg';

export default class StudentAttendance extends Component {
    state = {
        reportData: {
            activeStudents: { label: "", value: "" },
            classAttendance: "",
        },
        viewAll: false,
        attendenceList: [],
        fullAttendenceList: [],
        columnData: [],
        showLoader: true,
        showNameFilterDropdown: false,
        nameFilterItems: [{ id: 1, label: 'A -> Z' }, { id: 2, label: 'Z -> A' }],
        showAttendanceFilterDropdown: false,
        attendanceFilterItems: [{ id: 1, label: 'Highest' }, { id: 2, label: 'Lowest' }],
        activeNameFilterDropDownItem: -1,
        activeAttendanceFilterDropDownItem: -1,
        nameSearchFieldValue: '',
        isProgramManager: this.props.isProgramManager,
    }

    onViewAllClicked = () => {
        const status = this.state.viewAll;
        if (this.state.isProgramManager) {
            if (status === false) {
                this.setState({ viewAll: !status, showLoader: true, activeNameFilterDropDownItem: -1, activeAttendanceFilterDropDownItem: -1, attendenceList: [], nameSearchFieldValue: '' });
                this.props.show(status)
                this.getInstructorStudentAttendanceReport(true);
            } else {
                const updatedList = [...this.state.fullAttendenceList];
                this.setState({ viewAll: !status, activeNameFilterDropDownItem: -1, activeAttendanceFilterDropDownItem: -1, attendenceList: updatedList, nameSearchFieldValue: '' });
                this.props.show(status)
            }
        }

        else if (!this.state.isProgramManager) {
            this.props.hideReportsNavigation(status, 'StudentAttendance');
            if (status === false) {
                this.setState({ viewAll: !status, showLoader: true, activeNameFilterDropDownItem: -1, activeAttendanceFilterDropDownItem: -1, attendenceList: [], nameSearchFieldValue: '' });
                this.getInstructorStudentAttendanceReport(true);
            } else {
                const updatedList = [...this.state.fullAttendenceList];
                this.setState({ viewAll: !status, activeNameFilterDropDownItem: -1, activeAttendanceFilterDropDownItem: -1, attendenceList: updatedList, nameSearchFieldValue: '' });
            }
        }
    }

    // onDownloadReportClicked = () => {
    //     alert("Clicked");

    // }

    getInstructorStudentAttendanceReport = (full) => {

        ResourceAPIController.getInstructorStudentAttendanceReport(this.props.batchCode, this.props.moduleName, full)
            .then(response => {

                // console.log('getInstructorStudentAttendanceReport Data => ', response.result);

                this.setState({
                    showLoader: false,
                    reportData: response.result.reportData,
                    attendenceList: response.result.attendenceList,
                    fullAttendenceList: response.result.attendenceList,
                    columnData: response.result.columnData,
                });
            })
            .catch(err => {
                console.log('getInstructorStudentAttendanceReport error => ', err)
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    onNameFilterClicked = () => {
        let updatedState = this.state.showNameFilterDropdown;
        this.setState({ showNameFilterDropdown: !updatedState, showAttendanceFilterDropdown: false });
    }

    onAttendanceFilterClicked = () => {
        let updatedState = this.state.showAttendanceFilterDropdown;
        this.setState({ showAttendanceFilterDropdown: !updatedState, showNameFilterDropdown: false });
    }

    onDropDownItemClicked = (pos, isAttendance) => {
        // alert(pos + ' something ' + isAttendance);
        let updatedList = [...this.state.attendenceList];

        if (isAttendance !== true) {
            // -------- Sort by Name --------
            if (pos === 0) {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'ascending');
            } else {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'descending');
            }
            this.setState({
                attendenceList: updatedList,
                activeNameFilterDropDownItem: pos,
                activeAttendanceFilterDropDownItem: -1,
                showNameFilterDropdown: false
            })
        } else {
            // -------- Sort by Attendance --------
            if (pos === 0) {
                updatedList = updatedList.sort((a, b) => (b.overallGrade - a.overallGrade));
            } else {
                updatedList = updatedList.sort((a, b) => (a.overallGrade - b.overallGrade));
            }
            this.setState({
                attendenceList: updatedList,
                activeAttendanceFilterDropDownItem: pos,
                activeNameFilterDropDownItem: -1,
                showAttendanceFilterDropdown: false
            });
        }
    }

    nameSearchInputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ nameSearchFieldValue: updatedValue });
    }

    onNameSearchIconClick = (searchString) => {
        const updatedSearchString = searchString.toLowerCase();
        const newList = this.state.fullAttendenceList.filter(student => {
            if (student.name.toLowerCase().indexOf(updatedSearchString) !== -1) {
                return true;
            }
        });

        if (!IsListEmpty(newList)) {
            this.setState({ attendenceList: newList, showNameFilterDropdown: false, nameSearchFieldValue: searchString, activeNameFilterDropDownItem: -1, activeRatingFilterDropDownItem: -1 });
        } else {
            this.props.onFailureDialogShow('No student found with the matching name.', 'OKAY');
        }

    }

    clearSearchResults = () => {
        const updatedList = [...this.state.fullAttendenceList];
        this.setState({ attendenceList: updatedList, activeNameFilterDropDownItem: -1, showNameFilterDropdown: false, nameSearchFieldValue: '' });
    }

    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getInstructorStudentAttendanceReport(this.state.viewAll);
        }
    }

    componentDidUpdate(prevProps) {
        // const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getInstructorStudentAttendanceReport(this.state.viewAll);
        }
    }

    render() {
        return (
            <div className={classes.StudentAttendanceReportContainer}>
                <div className={[classes.ReportsPageHeading, classes.HeadingWithImg].join(' ')}>{this.state.isProgramManager && this.state.viewAll ? <><img src={TechLogo} alt="Module Logo" width="50" />Class Attendance</> : this.state.isProgramManager && !this.state.viewAll ? "Class Attendance" : "Student Attendance Report"}</div>
                {
                    this.state.showLoader
                        ? <div className={classes.LoaderContainer}><ShowLoader isLoading={true} /> </div>
                        : <div className={classes.GradesPageContainer}>
                            {this.state.viewAll ? null :
                                <div className={classes.ReportsCard}>
                                    <div >
                                        <div className={classes.GradesCardText}>Last Weeks Stats</div>
                                        <div className={classes.GradesCardContainer}>
                                            <div className={classes.ProgressComponentDiv}>
                                                <ProgressComponent
                                                    label="Active Students"
                                                    type="Fraction"
                                                    height="80px"
                                                    fractionText={this.state.reportData.activeStudents.label}
                                                    showProgressBar={true}
                                                    overallPercentage={this.state.reportData.activeStudents.value} />
                                            </div>
                                            <div className={classes.ProgressComponentDiv}>
                                                <ProgressComponent
                                                    label="Class Attendance"
                                                    type="Percentage"
                                                    height="80px"
                                                    fractionText={this.state.reportData.classAttendance}
                                                    showProgressBar={true}
                                                    overallPercentage={this.state.reportData.classAttendance} />
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            <div className={this.state.viewAll ? classes.LinkTextContainerFull : classes.LinkTextContainer}>
                                {/* <Button
                                    label="DOWNLOAD REPORT"
                                    fontSize="0.9em"
                                    styleclass="TextOnlyButtonBlue"
                                    padding="0px"
                                    margin="0em"
                                    clicked={this.onDownloadReportClicked} /> */}

                                <Button
                                    label={this.state.viewAll ? "BACK TO OVERVIEW" : "VIEW ALL"}
                                    fontSize="0.9em"
                                    styleclass="TextOnlyButtonBlue"
                                    padding="0px"
                                    margin="0em 0.5em"
                                    clicked={(e) => this.onViewAllClicked()} />
                            </div>
                            <StudentAttendanceTable
                                data={this.state.attendenceList}
                                columnData={this.state.columnData}
                                tableHead1={"Name"}
                                tableHead2={"Attendance"}
                                colHead1={"Class Average"}
                                colHead2={this.state.reportData.classAttendance}
                                viewAll={this.state.viewAll}

                                onNameFilterClicked={this.onNameFilterClicked}
                                onAttendanceFilterClicked={this.onAttendanceFilterClicked}
                                showNameFilterDropdown={this.state.showNameFilterDropdown}
                                showAttendanceFilterDropdown={this.state.showAttendanceFilterDropdown}
                                nameDropDownItems={this.state.nameFilterItems}
                                attendanceDropDownItems={this.state.attendanceFilterItems}
                                onDropDownClicked={this.onNameFilterClicked}
                                onDropDownItemClicked={this.onDropDownItemClicked}
                                activeNameDropdownItem={this.state.activeNameFilterDropDownItem}
                                activeAttendanceDropdownItem={this.state.activeAttendanceFilterDropDownItem}
                                nameSearchFieldValue={this.state.nameSearchFieldValue}
                                nameSearchInputChangeHandler={this.nameSearchInputChangeHandler}
                                onNameSearchIconClick={this.onNameSearchIconClick}
                                clearSearchResults={this.clearSearchResults}
                                searchString={this.state.nameSearchFieldValue}
                            />
                        </div>
                }
            </div>
        )
    }
}
